import React, { useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Card,
  Container,
  Link,
  Tab,
  Typography,
} from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Page from 'src/components/Page';
import DailyEscalationReport from 'src/sections/reports/DailyEscalationReport';
import MonthlyClientDashBoard from 'src/sections/reports/client/MonthlyClientDashBoard';
import DailyEscalationReportNew from 'src/sections/reports/DailyEscalationReportNew';

export default function USReports() {
  const [value, setValue] = useState('daily-escalation');

  const clientid = Number(localStorage.getItem('ID'));

  console.log('Client ID:', clientid);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Page title="Reports">
      <Container maxWidth="xxl">
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Reports</Typography>
          </Box>
          <Breadcrumbs separator="/" aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/" sx={{ fontSize: '0.875rem' }}>
              Dashboard
            </Link>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
              Reports
            </Typography>
          </Breadcrumbs>
        </Box>

        <Card>
          <TabContext value={value}>
            <TabList
              onChange={handleChange}
              aria-label="us report tabs"
              sx={{
                px: 2,
                bgcolor: 'background.neutral',
                '& .MuiTab-root': {
                  typography: 'body2',
                  fontWeight: 500,
                  color: 'text.secondary',
                  minHeight: 48,
                  '&.Mui-selected': {
                    color: 'text.primary',
                    fontWeight: 600,
                  },
                },
                '& .MuiTabs-indicator': {
                  bgcolor: 'primary.main',
                },
              }}
            >
              {clientid !== 1401 && (
                <Tab value="daily-escalation" label="Daily Escalation Report" />
              )}
              {clientid === 1401 && (
                <Tab value="daily-escalation" label="Retailer 360° solution Report" />
              )}
              {clientid !== 1401 && (
                <Tab value="monthly-surveillance" label="Monthly Surveillance Report" />
              )}
            </TabList>

            {clientid !== 1401 && (
              <TabPanel value="daily-escalation" sx={{ p: 0 }}>
                <DailyEscalationReport />
              </TabPanel>
            )}

            {clientid === 1401 && (
              <TabPanel value="daily-escalation" sx={{ p: 0 }}>
                <DailyEscalationReportNew />
              </TabPanel>
            )}

            <TabPanel value="monthly-surveillance" sx={{ p: 0 }}>
              <MonthlyClientDashBoard />
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </Page>
  );
}
